export enum Bets {
  straight = 'straight',
  split = 'split',
  street = 'street',
  corner = 'corner',
  line = 'line',
  column = 'column',
  red = 'red',
  black = 'black',
  odd = 'odd',
  even = 'even',
  low = 'low',
  high = 'high',
  dozen = 'dozen',
}

export type SelectorType = string[];

export interface IMakeBet {
  type: Bets;
  selector: SelectorType;
  chips?: number;
}

export interface IMakeBetPayload {
  bets: IMakeBet[];
  double?: boolean;
}

export interface IServerBet {
  selector: SelectorType;
  ratio?: number;
  bet?: number;
  isWin?: boolean;
}

export interface IClientBet extends IServerBet {
  type: string;
  label?: string;
  frequence?: number;
  confirmed?: number;
}

export interface IKeyValue<ValueType> {
  [key: string]: ValueType;
}

export type ClientBetsType = IKeyValue<IKeyValue<IClientBet>>;

export interface IBets {
  past: [] | ClientBetsType[];
  present: {} | ClientBetsType;
  future: [] | ClientBetsType[];
}

export enum Modes {
  full = 'full',
  small = 'small',
}

export type ModifiedBets = string[];

export interface ITableSurface {
  selected: ModifiedBets;
  raceTrackSelected: ModifiedBets;
  winners: ModifiedBets;
}

export interface ISelection {
  selector: string[];
  key: string;
}

export interface IBetsArea {
  bets: IBets;
  betsConfirmed: IClientBet[];
  tableSurface: ITableSurface;
  neighboursCount: number;
  mode: Modes;
}
